import { render, staticRenderFns } from "./DependentsComponent.vue?vue&type=template&id=aecc0912&scoped=true&"
import script from "./DependentsComponent.vue?vue&type=script&lang=js&"
export * from "./DependentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecc0912",
  null
  
)

export default component.exports